import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

const PorownaniePakietow = () => {
  const [activeTab, setActiveTab] = useState('1');

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const tabs = [
    { id: '1', label: 'Lekarze' },
    { id: '2', label: 'Badania laboratoryjne' },
    { id: '3', label: 'Badania obrazowe, endoskopowe i czynnościowe' },
    { id: '4', label: 'Zabiegi ambulatoryjne' },
    { id: '5', label: 'Pozostałe' }
  ];

  const baseStyle = {
    color: 'rgb(0, 60, 125)',
    fontWeight: '600',
    fontSize: '1.05rem',
    padding: '12px 18px',
    border: 'none',
    borderRadius: '6px 6px 0 0',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out'
  };

  const activeStyle = {
    backgroundColor: 'rgb(0, 60, 125)',
    color: 'white',
    fontWeight: '700'
  };
  return (
    <>
      <h3 className="page-header firstColor">Porównanie pakietów medycznych</h3>

      <Nav tabs style={{ borderBottom: '2px solid rgba(0, 60, 125, 0.2)' }}>
        {tabs.map((tab) => (
          <NavItem key={tab.id}>
            <NavLink
              onClick={() => toggle(tab.id)}
              style={{
                ...baseStyle,
                ...(activeTab === tab.id ? activeStyle : {})
              }}>
              {tab.label}
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <br />

      <TabContent activeTab={activeTab}>
        {/* --- TAB 1: LEKARZE --- */}
        <TabPane tabId="1">
          <span className="secondColor">
            Porady lekarskie realizowane są bez skierowania w sytuacjach
            chorobowych, udzielane przez lekarzy specjalistów wskazanych przez
            Świadczeniodawcę w godzinach pracy placówek medycznych oraz zgodnie
            z aktualnym harmonogramem pracy placówek.
          </span>
          <br />
          <br />
          <span className="secondColor">
            W przypadku gdy uprawnionym do świadczeń jest dziecko do 15. roku
            życia, dostęp do konsultacji specjalistycznych zależy od dostępności
            danego specjalisty dziecięcego w danej lokalizacji.
          </span>
          <br />
          <br />

          <table className="table table-striped table-condensed table-bordered secondColor">
            <tbody>
              <tr>
                <th style={{ width: '25%' }} className="text-center">
                  Standard
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Komfort
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Komfort Plus
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Optimum
                </th>
              </tr>

              <tr>
                {/* STANDARD */}
                <td>
                  <ul>
                    <li>internista (L) (T)</li>
                    <li>lekarz rodzinny (L) (T)</li>
                    <li>pediatra (L) (T)</li>
                    <li>chirurg ogólny (L) (T)</li>
                    <li>dermatolog (L) (T)</li>
                    <li>diabetolog (L) (T)</li>
                    <li>gastrolog (L) (T)</li>
                    <li>ginekolog (L) (T)</li>
                    <li>ginekolog-onkolog (L)</li>
                    <li>kardiolog (L) (T)</li>
                    <li>neurolog (L) (T)</li>
                    <li>okulista (L) (T)</li>
                    <li>onkolog (L) (T)</li>
                    <li>ortopeda (L) (T)</li>
                    <li>otolaryngolog (L) (T)</li>
                    <li>proktolog (L)</li>
                    <li>urolog (L) (T)</li>
                  </ul>
                </td>
                {/* KOMFORT */}
                <td>
                  <ul>
                    <li>internista (T)</li>
                    <li>lekarz rodzinny (T)</li>
                    <li>pediatra (T)</li>
                    <li>alergolog (T)</li>
                    <li>chirurg ogólny (T)</li>
                    <li>dermatolog (T)</li>
                    <li>diabetolog (T)</li>
                    <li>endokrynolog (T)</li>
                    <li>gastrolog (T)</li>
                    <li>ginekolog (T)</li>
                    <li>ginekolog-endokrynolog</li>
                    <li>ginekolog-onkolog</li>
                    <li>kardiolog (T)</li>
                    <li>neurolog (T)</li>
                    <li>okulista (T)</li>
                    <li>onkolog (T)</li>
                    <li>ortopeda (T)</li>
                    <li>otolaryngolog (T)</li>
                    <li>proktolog</li>
                    <li>urolog (T)</li>
                  </ul>
                </td>

                {/* KOMFORT PLUS */}
                <td>
                  <ul>
                    <li>internista (T)</li>
                    <li>lekarz rodzinny (T)</li>
                    <li>pediatra (T)</li>
                    <li>alergolog (T)</li>
                    <li>chirurg naczyniowy</li>
                    <li>chirurg ogólny (T)</li>
                    <li>chirurg onkolog</li>
                    <li>dermatolog (T)</li>
                    <li>diabetolog (T)</li>
                    <li>endokrynolog (T)</li>
                    <li>gastrolog (T)</li>
                    <li>ginekolog (T)</li>
                    <li>ginekolog-endokrynolog</li>
                    <li>ginekolog-onkolog</li>
                    <li>hematolog (T)</li>
                    <li>kardiolog (T)</li>
                    <li>lekarz chorób zakaźnych</li>
                    <li>lekarz medycyny podróży – medycyna tropikalna</li>
                    <li>lekarz medycyny sportowej</li>
                    <li>lekarz rehabilitacji</li>
                    <li>nefrolog (T)</li>
                    <li>neurochirurg (T)</li>
                    <li>neurolog (T)</li>
                    <li>okulista (T)</li>
                    <li>onkolog (T)</li>
                    <li>ortopeda (T)</li>
                    <li>otolaryngolog (T)</li>
                    <li>proktolog</li>
                    <li>pulmonolog (T)</li>
                    <li>reumatolog (T)</li>
                    <li>urolog (T)</li>
                  </ul>

                  <p>
                    <strong>Limit 4 wizyty w roku:</strong>
                  </p>
                  <ul>
                    <li>dietetyk* (T)</li>
                    <li>psychiatra</li>
                    <li>psycholog (T)</li>
                    <li>seksuolog</li>
                  </ul>
                </td>

                {/* OPTIMUM */}
                <td>
                  <ul>
                    <li>internista (T)</li>
                    <li>lekarz rodzinny (T)</li>
                    <li>pediatra (T)</li>
                    <li>alergolog (T)</li>
                    <li>chirurg naczyniowy</li>
                    <li>chirurg ogólny (T)</li>
                    <li>chirurg onkolog</li>
                    <li>dermatolog (T)</li>
                    <li>diabetolog (T)</li>
                    <li>endokrynolog (T)</li>
                    <li>gastrolog (T)</li>
                    <li>ginekolog (T)</li>
                    <li>ginekolog-endokrynolog</li>
                    <li>ginekolog-onkolog</li>
                    <li>hematolog (T)</li>
                    <li>kardiolog (T)</li>
                    <li>lekarz chorób zakaźnych</li>
                    <li>lekarz medycyny podróży – medycyna tropikalna</li>
                    <li>lekarz medycyny sportowej</li>
                    <li>lekarz rehabilitacji</li>
                    <li>nefrolog (T)</li>
                    <li>neurochirurg (T)</li>
                    <li>neurolog (T)</li>
                    <li>okulista (T)</li>
                    <li>onkolog (T)</li>
                    <li>ortopeda (T)</li>
                    <li>otolaryngolog (T)</li>
                    <li>proktolog</li>
                    <li>pulmonolog (T)</li>
                    <li>reumatolog (T)</li>
                    <li>urolog (T)</li>
                  </ul>

                  <p>
                    <strong>Limit 4 wizyty w roku:</strong>
                  </p>
                  <ul>
                    <li>dietetyk* (T)</li>
                    <li>psychiatra</li>
                    <li>psycholog (T)</li>
                    <li>seksuolog</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          <small>
            (T) – lekarz dostępny również w ramach usług telemedycznych
          </small>
          <br />
          <small>
            (L) – limit 12 wizyt rocznie (limit liczony dla wszystkich
            specjalizacji wizyt: stacjonarnych)
          </small>
          <br />
          <small>
            (T) – limit 6 wizyt rocznie (limit liczony łącznie dla wszystkich
            specjalizacji wizyt: telemedycznych)
          </small>
          <br />
          <br />

          <small>
            * Konsultacja z dietetykiem dostępna w zakresie Komfort Plus i
            Optimum nie obejmuje opracowania planu dietetycznego.
          </small>
          <br />
          <small>
            Szczegółowe opisy zakresów dostępne w sekcji{' '}
            <a
              href="https://tvp-tuwpzuw.uspartner.pl/pracownicy2026/dokumenty/"
              target="_blank"
              rel="noopener noreferrer">
              Dokumenty do pobrania
            </a>
            .
          </small>
        </TabPane>

        {/* --- TAB 2: BADANIA LABORATORYJNE --- */}
        <TabPane tabId="2">
          <table className="table table-striped table-condensed table-bordered">
            <tbody>
              <tr>
                <th style={{ width: '25%' }} className="text-center">
                  Standard
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Komfort
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Komfort Plus
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Optimum
                </th>
              </tr>
              <tr>
                <td>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Kategoria badań</th>
                        <th>Liczba rodzajów badań</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Morfologia krwi obwodowej</td>
                        <td>4</td>
                      </tr>
                      <tr>
                        <td>Układ krzepnięcia</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td>Badania biochemiczne</td>
                        <td>28</td>
                      </tr>
                      <tr>
                        <td>Badania serologiczne</td>
                        <td>5</td>
                      </tr>
                      <tr>
                        <td>Diagnostyka zakażeń</td>
                        <td>1</td>
                      </tr>
                      <tr>
                        <td>Badania hormonalne</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td>Badania moczu</td>
                        <td>1</td>
                      </tr>
                      <tr>
                        <td>Badania kału</td>
                        <td>1</td>
                      </tr>
                      <tr>
                        <td>Testy alergiczne</td>
                        <td>-</td>
                      </tr>
                      <tr>
                        <td>Badania inne</td>
                        <td>2</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Kategoria badań</th>
                        <th>Liczba rodzajów badań</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Morfologia krwi obwodowej</td>
                        <td>4</td>
                      </tr>
                      <tr>
                        <td>Układ krzepnięcia</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td>Badania biochemiczne</td>
                        <td>32</td>
                      </tr>
                      <tr>
                        <td>Badania serologiczne</td>
                        <td>7</td>
                      </tr>
                      <tr>
                        <td>Diagnostyka zakażeń</td>
                        <td>21</td>
                      </tr>
                      <tr>
                        <td>Badania hormonalne</td>
                        <td>4</td>
                      </tr>
                      <tr>
                        <td>Badania moczu</td>
                        <td>1</td>
                      </tr>
                      <tr>
                        <td>Badania kału</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td>Testy alergiczne</td>
                        <td>5</td>
                      </tr>
                      <tr>
                        <td>Badania inne</td>
                        <td>2</td>
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Kategoria badań</th>
                        <th>Liczba rodzajów badań</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Morfologia krwi obwodowej</td>
                        <td>4</td>
                      </tr>
                      <tr>
                        <td>Układ krzepnięcia</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td>Badania biochemiczne</td>
                        <td>35</td>
                      </tr>
                      <tr>
                        <td>Badania serologiczne</td>
                        <td>19</td>
                      </tr>
                      <tr>
                        <td>Diagnostyka zakażeń</td>
                        <td>34</td>
                      </tr>
                      <tr>
                        <td>Badania hormonalne</td>
                        <td>6</td>
                      </tr>
                      <tr>
                        <td>Badania moczu</td>
                        <td>1</td>
                      </tr>
                      <tr>
                        <td>Badania biopsyjne</td>
                        <td>6</td>
                      </tr>
                      <tr>
                        <td>Badania kału</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td>Testy alergiczne</td>
                        <td>5</td>
                      </tr>
                      <tr>
                        <td>Badania inne</td>
                        <td>4</td>
                      </tr>
                    </tbody>
                  </table>
                </td>

                <td>
                  <p>
                    Diagnostyka laboratoryjna i obrazowa realizowana zgodnie ze
                    wskazaniami medycznymi na podstawie skierowania do lekarza
                    Świadczeniodawcy we wskazanych przez Świadczeniodawcę
                    placówkach za pośrednictwem infolinii medycznej.
                  </p>
                  <p>
                    Nie obejmuje badań genetycznych i eksperymentalnych, testów
                    RE-PCR oraz antygenowych pod kątem COVID-19.
                  </p>
                  <p>
                    Obejmuje inne, niewymienione w zakresie badania. Cena
                    badania jednostkowego w placówce nie może przekroczyć
                    1&nbsp;500 zł.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>

          {/* <small>
            Szczegółowe opisy zakresów dostępne w sekcji{' '}
            <a
              href="https://tvp-tuwpzuw.uspartner.pl/pracownicy2026/dokumenty/"
              target="_blank"
              rel="noopener noreferrer">
              Dokumenty do pobrania
            </a>
            .
          </small> */}
        </TabPane>

        {/* --- TAB 3: BADANIA DIAGNOSTYCZNE (OBRAZOWE, ENDOSKOPOWE I CZYNNOŚCIOWE) --- */}
        <TabPane tabId="3" style={{ padding: 0 }}>
          <table className="table table-striped table-bordered">
            <tbody>
              <tr>
                <th style={{ width: '25%' }} className="text-center">
                  Standard
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Komfort
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Komfort Plus
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Optimum
                </th>
              </tr>
              <tr>
                {/*Standard */}
                <td>
                  <p>
                    <strong>Badania radiologiczne (RTG):</strong>
                  </p>
                  <ul>
                    <li>czaszki</li>
                    <li>zatok nosa</li>
                    <li>
                      klatki piersiowej w projekcji Pa i bocznej – również z
                      barytem, tkanek miękkich klatki piersiowej
                    </li>
                    <li>kręgosłupa</li>
                    <li>stawów, kończyny górnej, kończyny dolnej</li>
                    <li>miednicy</li>
                    <li>przeglądowe jamy brzusznej</li>
                  </ul>

                  <p>
                    <strong>Badania czynnościowe:</strong>
                  </p>
                  <ul>
                    <li>EKG spoczynkowe</li>
                    <li>spirometria</li>
                    <li>audiometria tonalna</li>
                    <li>audiometria impedancyjna (tympanogram)</li>
                  </ul>

                  <p>
                    <strong>Badania ultrasonograficzne (USG):</strong>
                  </p>
                  <ul>
                    <li>gruczołu krokowego przez powłoki brzuszne</li>
                    <li>ginekologiczne przez powłoki brzuszne</li>
                    <li>ginekologiczne przezpochwowe (transwaginalne)</li>
                    <li>piersi</li>
                    <li>
                      przeglądowe jamy brzusznej i przewodu pokarmowego
                      (trzustki, wątroby, dróg żółciowych, żołądka, dwunastnicy)
                    </li>
                    <li>ciąży</li>
                  </ul>
                </td>
                {/* Komfort */}
                <td>
                  <p>
                    <strong>Badania radiologiczne (RTG):</strong>
                  </p>
                  <ul>
                    <li>czaszki, zatok nosa</li>
                    <li>
                      klatki piersiowej w projekcji PA i bocznej – również z
                      barytem
                    </li>
                    <li>kręgosłupa</li>
                    <li>stawów, kończyny górnej, kończyny dolnej</li>
                    <li>miednicy</li>
                    <li>przeglądowe jamy brzusznej</li>
                    <li>mammografia</li>
                  </ul>

                  <p>
                    <strong>Badania czynnościowe:</strong>
                  </p>
                  <ul>
                    <li>EKG spoczynkowe</li>
                    <li>spirometria</li>
                    <li>audiometria tonalna</li>
                    <li>audiometria impedancyjna (tympanogram)</li>
                  </ul>

                  <p>
                    <strong>Badania inne:</strong>
                  </p>
                  <ul>
                    <li>
                      densytometria kręgosłupa, kości udowej, kości obu rąk
                    </li>
                  </ul>

                  <p>
                    <strong>Badania ultrasonograficzne (USG):</strong>
                  </p>
                  <ul>
                    <li>gruczołu krokowego przez powłoki brzuszne</li>
                    <li>gruczołu krokowego transrektalne</li>
                    <li>ginekologiczne przez powłoki brzuszne</li>
                    <li>ginekologiczne przezpochwowe (transwaginalne)</li>
                    <li>piersi</li>
                    <li>przeglądowe jamy brzusznej i przewodu pokarmowego</li>
                    <li>tarczycy</li>
                    <li>
                      stawów (biodrowych, kolanowych, łokciowych, skokowych,
                      barkowych)
                    </li>
                    <li>drobnych stawów i więzadeł, ścięgna</li>
                    <li>jąder, ciąży, ślinianek</li>
                    <li>echokardiografia (ECHO)</li>
                  </ul>
                </td>

                {/* Komfort Plus */}
                <td>
                  <p>
                    <strong>
                      Badania radiologiczne (RTG) – rozszerzony zakres:
                    </strong>
                  </p>
                  <p>
                    RTG: czaszki, siodło tureckie, kości twarzy okolicy
                    czołowej, żuchwy, szczęki, zatok nosa, nosa, oczodołu,
                    krtani, przewodu nosowo-łzowego, nosogardzieli, gruczołów
                    ślinowych, okolicy tarczycy, języczka, klatki piersiowej w
                    projekcji PA i bocznej – również z barytem, tkanek miękkich
                    klatki piersiowej, kręgosłupa (całego, szyjnego,
                    piersiowego, lędźwiowo-krzyżowego), barku, łopatki, mostka,
                    żeber, stawów, ramienia, łokcia, przedramienia, nadgarstka,
                    dłoni, kości łódeczkowej, palca, kończyny górnej, kończyny
                    dolnej, miednicy, biodra, uda, kolana, podudzia, kostki,
                    stopy, osiowe rzepki, przeglądowe jamy brzusznej,
                    mammografia, urografia (zdjęcie nerek, moczowodów i
                    pęcherza), wlew doodbytniczy – kontrast.
                  </p>

                  <p>
                    <strong>Badania czynnościowe – rozszerzony zakres:</strong>
                  </p>
                  <ul>
                    <li>EKG spoczynkowe</li>
                    <li>
                      pomiar całodobowy ciśnienia tętniczego (metodą holtera
                      ciśnieniowego)
                    </li>
                    <li>
                      EEG w czuwaniu, EEG Holter, EEG – badanie zwykle papierowe
                    </li>
                    <li>EMG – badanie ilościowe jednego mięśnia</li>
                    <li>
                      EMG – elektrostymulacyjna próba męczliwości jednego
                      mięśnia (próba miasteniczna)
                    </li>
                    <li>EMG – próba ischemiczna (tężyczkowa)</li>
                    <li>
                      ENG – elektroneurografia – badania przewodzenia we
                      włóknach (ruchowych lub czuciowych) jednego nerwu + fala F
                    </li>
                    <li>potencjały wywoływane somatosensorycznie</li>
                    <li>próba błędnikowa – elektronystagmografia (ENG)</li>
                    <li>próba uczuleniowa</li>
                    <li>spirometria</li>
                    <li>audiometria tonalna i impedancyjna (tympanogram)</li>
                    <li>badanie uroflowmetryczne</li>
                    <li>polisomnografia</li>
                  </ul>

                  <p>
                    <strong>
                      Badania ultrasonograficzne (USG) – rozszerzony zakres +
                      dopplerowskie:
                    </strong>
                  </p>
                  <p>
                    USG: gruczołu krokowego przez powłoki brzuszne, gruczołu
                    krokowego transrektalne, ginekologiczne przez powłoki
                    brzuszne, ginekologiczne przezpochwowe (transwaginalne),
                    miednicy małej, piersi, przeglądowe jamy brzusznej i
                    przewodu pokarmowego (trzustki, wątroby, dróg żółciowych,
                    żołądka, dwunastnicy), układu moczowego (nerek, moczowodów,
                    pęcherza moczowego), tarczycy, mięśni, stawów: biodrowych,
                    kolanowych, łokciowych, skokowych, barkowych, drobnych
                    stawów i więzadeł, ścięgna, węzłów chłonnych, krtani,
                    nadgarstka, śródręcza i palca, tkanek miękkich, opłucnej,
                    klatki piersiowej, przezciemiączkowe u dzieci, jąder, ciąży,
                    ślinianek, echokardiografia (ECHO).
                  </p>
                  <p>
                    USG dopplerowskie: naczyń jamy brzusznej, szyi, kończyn z
                    tętnic (jedna kończyna), kończyn z tętnic (obie kończyny),
                    kończyn z żył (jedna kończyna), kończyn z żył (obie
                    kończyny), kończyn z żył i tętnic (jedna kończyna), kończyn
                    z żył i tętnic (obie kończyny), tętnic nerkowych, tętnic
                    wewnątrzczaszkowych.
                  </p>

                  <p>
                    <strong>Diagnostyka obrazowa TK i NMR:</strong>
                  </p>
                  <ul>
                    <li>
                      TK i NMR: głowy (przysadki, zatok, oczodołów, kości
                      skroniowych), szyi, krtani, uszu
                    </li>
                    <li>
                      tkanek miękkich szyi, klatki piersiowej, jamy brzusznej,
                      miednicy
                    </li>
                    <li>
                      kości, stawów, kręgosłupa (całego, szyjnego, piersiowego,
                      lędźwiowego)
                    </li>
                    <li>
                      kończyn górnych i dolnych (ręki, ramienia, przedramienia,
                      nadgarstka, uda, podudzia, stopy)
                    </li>
                    <li>badania angio, urografia</li>
                  </ul>

                  <p>
                    <strong>Badania endoskopowe:</strong>
                  </p>
                  <ul>
                    <li>
                      gastroskopia/gastrofiberoskopia (z możliwością wykonania
                      testu ureazowego)
                    </li>
                    <li>sigmoidoskopia, rektoskopia</li>
                    <li>kolonoskopia, anoskopia</li>
                    <li>cystoskopia, bronchoskopia</li>
                  </ul>

                  <p>
                    <strong>Badania inne:</strong>
                  </p>
                  <ul>
                    <li>
                      densytometria: kręgosłupa, kości udowej, kości obu rąk
                    </li>
                  </ul>
                </td>

                {/* Optimum */}
                <td>
                  <p>
                    Diagnostyka laboratoryjna i obrazowa realizowana zgodnie ze
                    wskazaniami medycznymi na podstawie skierowania do lekarza
                    Świadczeniodawcy we wskazanych przez Świadczeniodawcę
                    placówkach za pośrednictwem infolinii medycznej.
                  </p>
                  <p>
                    Nie obejmuje badań genetycznych i eksperymentalnych, testów
                    RE-PCR oraz antygenowych pod kątem COVID-19.
                  </p>
                  <p>
                    Obejmuje inne, niewymienione w zakresie badania. Cena
                    badania jednostkowego w placówce nie może przekroczyć
                    1&nbsp;500 zł.
                  </p>
                </td>
              </tr>
            </tbody>
          </table>

          {/* <small>
            Szczegółowe opisy zakresów dostępne w sekcji{' '}
            <a
              href="https://tvp-tuwpzuw.uspartner.pl/pracownicy2026/dokumenty/"
              target="_blank"
              rel="noopener noreferrer">
              Dokumenty do pobrania
            </a>
            .
          </small> */}
        </TabPane>

        {/* --- TAB 4: ZABIEGI AMBULATORYJNE --- */}
        <TabPane tabId="4">
          <table className="table table-striped table-condensed table-bordered">
            <tbody>
              <tr>
                <th style={{ width: '25%' }} className="text-center">
                  Standard
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Komfort
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Komfort Plus
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Optimum
                </th>
              </tr>
              <tr>
                <td colSpan="4">
                  Zabiegi wykonywane są w ramach porady lekarskiej przez lekarza
                  lub pielęgniarkę, z zastrzeżeniem, że istnieje wskazanie
                  medyczne i możliwość wykonania czynności w warunkach
                  ambulatoryjnych w danej placówce bez szkody dla
                  Ubezpieczonego.
                </td>
              </tr>
              <tr>
                <td>
                  <ul>
                    <li>nacięcie i drenaż ropnia</li>
                    <li>szycie rany</li>
                    <li>założenia i zmiana opatrunku </li>
                    <li>zdjęcie szwów</li>
                    <li>pobieranie materiału do badania cytologicznego </li>
                    <li>badanie dna oka</li>
                    <li>badanie ostrości widzenia</li>
                    <li>pomiar ciśnienia śródgałkowego </li>
                    <li>usunięcie ciała obcego </li>
                    <li>dobór szkieł korekcyjnych</li>
                    <li>
                      opatrzenie drobnych urazów (skręcenia, zwichnięcia,
                      nieskomplikowane złamania – bez kosztów stabilizatorów i
                      gipsu)
                    </li>
                    <li>płukanie uszu </li>
                    <li>przedmuchiwanie trąbki słuchowej</li>
                    <li>usunięcie ciała obcego z ucha/nosa/gardła</li>
                    <li>założenie/zmiana przedniej tamponady nosa</li>
                    <li>założenie temblaka </li>
                    <li>pobieranie materiałów do badań mikrobiologicznych </li>
                    <li>
                      opatrzenie drobnych urazów (rany, skręcenia, zwichnięcia,
                      nieskomplikowane złamania – bez kosztu stabilizatorów i
                      gipsu
                    </li>
                    <li>usunięcie kleszcza</li>
                    <li>iniekcje: domięśniowe, dożylne, podskórne</li>
                    <li>podłączenie wlewu kroplowego</li>
                    <li>pobieranie krwi </li>
                    <li>test troponinowy</li>
                  </ul>
                </td>
                <td colSpan="3">
                  <ul>
                    <li>odczulanie (bez kosztu podawanych leków)</li>
                    <li>nacięcie i drenaż ropnia</li>
                    <li>szycie rany</li>
                    <li>założenie i zmiana opatrunku</li>
                    <li>zdjęcie szwów</li>
                    <li>pobieranie materiału do badania cytologicznego</li>
                    <li>badanie dna oka</li>
                    <li>badanie ostrości widzenia</li>
                    <li>pomiar ciśnienia śródgałkowego</li>
                    <li>usunięcie ciała obcego</li>
                    <li>dobór szkieł korekcyjnych</li>
                    <li>
                      opatrzenie drobnych urazów (skręcenia, zwichnięcia,
                      nieskomplikowane złamania – bez kosztów stabilizatorów i
                      gipsu)
                    </li>
                    <li>założenie temblaka</li>
                    <li>założenie/zdjęcie gipsu (w tym gipsu lekkiego)</li>
                    <li>płukanie uszu</li>
                    <li>przedmuchiwanie trąbki słuchowej</li>
                    <li>usunięcie ciała obcego z ucha/nosa/gardła</li>
                    <li>punkcja w tym m.in. zatoki szczękowej</li>
                    <li>założenie/zmiana przedniej tamponady nosa</li>
                    <li>pobieranie materiałów do badań mikrobiologicznych</li>
                    <li>
                      opatrzenie drobnych urazów (rany, skręcenia, zwichnięcia,
                      nieskomplikowane złamania – bez kosztu stabilizatorów i
                      gipsu)
                    </li>
                    <li>usunięcie kleszcza</li>
                    <li>opatrunki związane z oparzeniami</li>
                    <li>iniekcje: domięśniowe, dożylne, podskórne</li>
                    <li>podłączenie wlewu kroplowego</li>
                    <li>pobieranie krwi</li>
                    <li>test troponinowy</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>

          {/* <small>
            Szczegółowe opisy zakresów dostępne w sekcji{' '}
            <a
              href="https://tvp-tuwpzuw.uspartner.pl/pracownicy2026/dokumenty/"
              target="_blank"
              rel="noopener noreferrer">
              Dokumenty do pobrania
            </a>
            .
          </small> */}
        </TabPane>

        {/* --- TAB 5: POZOSTAŁE --- */}
        <TabPane tabId="5">
          <table className="table table-striped table-condensed table-bordered">
            <tbody>
              <tr>
                <th style={{ width: '25%' }} className="text-center">
                  Świadczenie
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Standard
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Komfort
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Komfort Plus
                </th>
                <th style={{ width: '25%' }} className="text-center">
                  Optimum
                </th>
              </tr>

              {/* Pakiet Profilaktyczny */}
              <tr>
                <th className="text-center">Pakiet Profilaktyczny</th>
                <td colSpan="4">
                  <p>Raz w roku bez skierowania:</p>
                  <ul>
                    <li>morfologia krwi z pełnym różnicowaniem granulocytów</li>
                    <li>glukoza</li>
                    <li>lipidogram</li>
                    <li>mocz – badanie ogólne</li>
                    <li>standardowa cytologia ginekologiczna</li>
                  </ul>
                </td>
              </tr>

              {/* Konsultacje lekarzy pomocy doraźnej */}
              <tr>
                <th className="text-center">
                  Konsultacje lekarzy pomocy doraźnej
                </th>
                <td className="text-center">-</td>

                <td colSpan="3">
                  <p>
                    Porady obejmują tylko przypadki nagłych zachorowań lub
                    nagłego pogorszenia stanu zdrowia, z wyłączeniem stanów
                    bezpośredniego zagrożenia życia. Decyzja o konieczności
                    realizacji konsultacji lekarza pomocy doraźnej podejmowana
                    jest na podstawie przeprowadzonego wywiadu.
                  </p>
                  <ul>
                    <li>lekarz pomocy doraźnej internistycznej</li>
                    <li>lekarz pomocy doraźnej pediatrycznej</li>
                    <li>pomoc ortopedyczna</li>
                    <li>pomoc chirurgiczna</li>
                  </ul>
                </td>
              </tr>

              {/* Hot line */}
              <tr>
                <th className="text-center">Hot line</th>
                <td className="text-center">-</td>

                <td colSpan="3">
                  <p>
                    Całodobowa infolinia medyczna, dostępna 7 dni w tygodniu,
                    również w święta i dni ustawowo wolne od pracy, gdzie można
                    otrzymać pielęgniarską telekonsultację medyczną.
                  </p>
                  <p>Pielęgniarka w ramach posiadanych uprawnień zawodowych:</p>
                  <ul>
                    <li>zidentyfikuje problem medyczny,</li>
                    <li>
                      udzieli porady medycznej, jeśli dany przypadek na to
                      pozwala,
                    </li>
                    <li>
                      wystawi receptę na leki niezbędne do leczenia zgłoszonego
                      problemu zdrowotnego, na wystawienie których pozwalają
                      pielęgniarskie uprawnienia zawodowe.
                    </li>
                  </ul>
                </td>
              </tr>

              {/* Prowadzenie cięzy*/}
              <tr>
                <th className="text-center">Prowadzenie ciąży</th>
                <td colSpan="4">
                  <p>
                    Prowadzenie ciąży fizjologicznej obejmuje opiekę lekarza
                    ginekologa, konsultacje i badania diagnostyczne oraz czynne
                    poradnictwo w zakresie fizjologii przebiegu ciąży i porodu,
                    zgodnie z zakresem ubezpieczenia. Badania realizowane
                    zgodnie ze wskazaniami medycznymi na podstawie skierowania w
                    placówkach wskazanych przez Świadczeniodawcę za
                    pośrednictwem infolinii medycznej lub serwisu moje.pzu.pl.
                  </p>
                </td>
              </tr>

              {/* Telekonsultacja z połozną*/}
              <tr>
                <th className="text-center">Telekonsultacja z położną</th>
                <td colSpan="4">
                  <p>
                    Tematem rozmowy z położną w ramach jej posiadanych uprawnień
                    zawodowych jest poradnictwo dotyczące: zdrowego stylu życia
                    w ciąży, fizjologii przebiegu ciąży i porodu, połogu,
                    pielęgnacji i żywienia noworodka.
                  </p>
                </td>
              </tr>

              {/* Szczepienia */}
              <tr>
                <th className="text-center">Szczepienia</th>
                <td className="text-center">-</td>

                <td>
                  <p>Bezpłatnie, raz w roku:</p>
                  <ul>
                    <li>Szczepienie przeciwko grypie sezonowej</li>
                  </ul>
                  <p>Bezpłatnie, bez limitu:</p>
                  <ul>
                    <li>Anatoksyna przeciw tężcowi</li>
                    <li>Szczepienie przeciwko błonicy</li>
                  </ul>
                </td>
                <td>
                  <p>Bezpłatnie, raz w roku:</p>
                  <ul>
                    <li>Szczepienie przeciwko grypie sezonowej</li>
                  </ul>
                  <p>Bezpłatnie, bez limitu:</p>
                  <ul>
                    <li>Anatoksyna przeciw tężcowi</li>
                    <li>Szczepienie przeciwko błonicy</li>
                  </ul>
                </td>
                <td>
                  <p>Bezpłatnie, raz w roku:</p>
                  <ul>
                    <li>Szczepienie przeciwko grypie sezonowej</li>
                  </ul>
                  <p>Bezpłatnie, bez limitu:</p>
                  <ul>
                    <li>Anatoksyna przeciw tężcowi</li>
                    <li>Szczepienie przeciwko błonicy</li>
                    <li>
                      Szczepienie przeciwko odkleszczowemu zapaleniu opon
                      mózgowych i mózgu
                    </li>
                    <li>Szczepienie przeciwko odrze, śwince, różyczce</li>
                  </ul>
                </td>
              </tr>

              {/* Rehabilitacja */}
              <tr>
                <th className="text-center">Rehabilitacja</th>
                <td className="text-center">-</td>
                <td className="text-center">-</td>

                <td>Bezpłatnie, 30 zabiegów w roku</td>
                <td>Bezpłatnie, bez limitu</td>
              </tr>

              {/* Wizyty domowe */}
              <tr>
                <th className="text-center">Wizyty domowe</th>
                <td className="text-center">-</td>

                <td>Bezpłatnie, 2 wizyty w roku</td>
                <td>Bezpłatnie, 2 wizyty w roku</td>
                <td>Bezpłatnie, 2 wizyty w roku</td>
              </tr>

              {/* Chirurgia jednego dnia */}
              <tr>
                <th className="text-center">Chirurgia jednego dnia</th>
                <td className="text-center">-</td>
                <td className="text-center">-</td>
                <td className="text-center">-</td>

                <td>Bezpłatnie, bez limitu**</td>
              </tr>

              {/* Stomatologia zachowawcza */}
              <tr>
                <th className="text-center">Stomatologia zachowawcza</th>
                <td>
                  Bezpłatny przegląd stomatologiczny raz w roku oraz 20% zniżki
                  na 29 rodzajów zabiegów
                </td>
                <td>
                  Bezpłatny przegląd stomatologiczny, lakierowanie, instruktaż
                  higieny, polerowanie, scaling, piaskowanie, lakowanie - jeden
                  ząb i fluoryzacja raz w roku oraz 10% zniżki na 22 rodzaje
                  zabiegów stomatologii zachowawczej
                </td>
                <td>
                  <p>
                    Bezpłatny przegląd stomatologiczny, lakierowanie, instruktaż
                    higieny, polerowanie, scaling, piaskowanie, lakowanie –
                    jeden ząb i fluoryzacja raz w roku oraz 10% zniżki na 22
                    rodzaje zabiegów stomatologii zachowawczej
                  </p>
                </td>
                <td>
                  <p>
                    Bezpłatny przegląd stomatologiczny raz w roku oraz 50%
                    zniżki na 30 rodzajów zabiegów stomatologii zachowawczej
                  </p>
                </td>
              </tr>
              <tr>
                <th>Refundacja</th>
                <td>
                  Refundacja cennikowa - Kwota z rachunku (faktury) nie więcej
                  niż kwota wskazana w cenniku refundacyjnym
                </td>
                <td colSpan={3}>
                  Refundacja procentowa 70% kwoty z rachunku (faktury) do 2 000
                  zł rocznie
                </td>
              </tr>
            </tbody>
          </table>
          <small>** Dostęp do usług po upływie 3-miesięcznej karencji.</small>
          {/* <small>
            Szczegółowe opisy zakresów dostępne w sekcji{' '}
            <a
              href="https://tvp-tuwpzuw.uspartner.pl/pracownicy2026/dokumenty/"
              target="_blank"
              rel="noopener noreferrer">
              Dokumenty do pobrania
            </a>
            .
          </small> */}
        </TabPane>
      </TabContent>
    </>
  );
};

export default PorownaniePakietow;
